module.exports = __webpack_public_path__ + "static/media/Will_Christenson_Resume_2018_C.e3be134b.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/Will_Christenson_Resume_2018_C.pdf
// module id = 87
// module chunks = 0